function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1289",
  "data-name": "Group 1289",
  transform: "translate(-1284.742 -321)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(1475.396 445.903)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M371.517,232.152H297.106a22.013,22.013,0,0,0,8.783,12.886q6.514,4.5,16.335,4.5a33.575,33.575,0,0,0,12.748-2.2,37.336,37.336,0,0,0,10.859-7.192l18.886,20.778Q349.8,278.505,321.091,278.5q-17.944,0-31.539-7.192a51.889,51.889,0,0,1-21.058-19.979,60.074,60.074,0,0,1-.189-57.64,52.071,52.071,0,0,1,20.114-19.878,61.287,61.287,0,0,1,56.659-.5,49.338,49.338,0,0,1,19.734,19.379q7.27,12.69,7.272,30.069Q372.084,223.163,371.517,232.152Zm-67.894-33.566q-5.574,5-7.083,13.587h41.927q-1.514-8.59-7.082-13.587a21.789,21.789,0,0,0-27.762,0Z",
  transform: "translate(-261.034 -166.62)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(1354.776 561.582)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M131.614,338.241a7.874,7.874,0,0,1-2.415.949,13.344,13.344,0,0,1-3.034.33q-4.377,0-6.729-2.145t-2.352-6.4v-7.512h-3.262V317.6h3.262v-5.82h7.843v5.82h5.119v5.862h-5.119v7.43a2.634,2.634,0,0,0,.64,1.878,2.241,2.241,0,0,0,1.713.682,4.141,4.141,0,0,0,2.394-.7Z",
  transform: "translate(-113.821 -308.522)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M149.8,318.189a11.837,11.837,0,0,1,4.4-.764v7.058a16.171,16.171,0,0,0-1.776-.123,5.468,5.468,0,0,0-3.942,1.361,5.526,5.526,0,0,0-1.425,4.169v10.279h-7.844V317.8h7.473v2.683A7.3,7.3,0,0,1,149.8,318.189Z",
  transform: "translate(-118.408 -309.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M178.992,319.963q2.93,2.539,2.931,7.781v12.424h-7.307V337.28q-1.694,3.261-6.606,3.259a10.347,10.347,0,0,1-4.5-.907,6.655,6.655,0,0,1-2.869-2.456,6.5,6.5,0,0,1-.97-3.529,5.728,5.728,0,0,1,2.435-4.933q2.435-1.753,7.513-1.753h4.459q-.206-3.551-4.747-3.55a10.911,10.911,0,0,0-3.262.515,8.668,8.668,0,0,0-2.807,1.425l-2.642-5.325a14.631,14.631,0,0,1,4.52-1.919,21.432,21.432,0,0,1,5.346-.682Q176.061,317.425,178.992,319.963Zm-6.4,14.962a3.673,3.673,0,0,0,1.486-1.939v-1.94h-3.386q-3.428,0-3.427,2.27a2,2,0,0,0,.785,1.651,3.377,3.377,0,0,0,2.146.619A4.342,4.342,0,0,0,172.593,334.926Z",
  transform: "translate(-122.104 -309.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M216.775,307.8v30.628H209.3V336.2q-2.189,2.6-6.565,2.6a11.129,11.129,0,0,1-5.573-1.423,10.291,10.291,0,0,1-3.984-4.066,13.426,13.426,0,0,1,0-12.2,10.185,10.185,0,0,1,3.984-4.024,11.261,11.261,0,0,1,5.573-1.4A8.124,8.124,0,0,1,208.931,318V307.8Zm-9.042,23.342a5.573,5.573,0,0,0,1.322-3.942,5.494,5.494,0,0,0-1.3-3.88,4.38,4.38,0,0,0-3.365-1.4,4.445,4.445,0,0,0-3.385,1.4,5.436,5.436,0,0,0-1.321,3.88A5.569,5.569,0,0,0,201,331.145a4.41,4.41,0,0,0,3.385,1.424A4.365,4.365,0,0,0,207.734,331.145Z",
  transform: "translate(-127.892 -307.803)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M250.884,330.964H234.618a4.544,4.544,0,0,0,1.921,2.661,6.4,6.4,0,0,0,3.571.93,7.7,7.7,0,0,0,2.786-.455,8.171,8.171,0,0,0,2.374-1.486l4.128,4.293q-3.262,3.632-9.536,3.631a15.225,15.225,0,0,1-6.894-1.485,10.947,10.947,0,0,1-6.234-10.113,11.041,11.041,0,0,1,5.987-10.03,14.087,14.087,0,0,1,12.384-.1,10.533,10.533,0,0,1,4.316,4,11.765,11.765,0,0,1,1.589,6.212Q251.008,329.107,250.884,330.964Zm-14.841-6.934a4.656,4.656,0,0,0-1.549,2.805h9.165a4.669,4.669,0,0,0-1.549-2.805,4.971,4.971,0,0,0-6.068,0Z",
  transform: "translate(-134.218 -309.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M277.8,319.963q2.932,2.539,2.932,7.781v12.424H273.42V337.28q-1.694,3.261-6.606,3.259a10.346,10.346,0,0,1-4.5-.907,6.662,6.662,0,0,1-2.869-2.456,6.507,6.507,0,0,1-.97-3.529,5.727,5.727,0,0,1,2.436-4.933q2.435-1.753,7.513-1.753h4.46q-.206-3.551-4.748-3.55a10.927,10.927,0,0,0-3.262.515,8.689,8.689,0,0,0-2.808,1.425l-2.641-5.325a14.623,14.623,0,0,1,4.52-1.919,21.427,21.427,0,0,1,5.346-.682Q274.863,317.425,277.8,319.963Zm-6.4,14.962a3.668,3.668,0,0,0,1.488-1.939v-1.94H269.5q-3.425,0-3.426,2.27a1.994,1.994,0,0,0,.784,1.651,3.379,3.379,0,0,0,2.148.619A4.332,4.332,0,0,0,271.4,334.926Z",
  transform: "translate(-139.952 -309.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M311.31,317.09a10.237,10.237,0,0,1,3.963,4.024,13.426,13.426,0,0,1,0,12.2,10.345,10.345,0,0,1-3.963,4.066,11.019,11.019,0,0,1-5.554,1.423q-4.417,0-6.6-2.6v2.229H291.68V307.8h7.843V318a8.345,8.345,0,0,1,6.234-2.311A11.149,11.149,0,0,1,311.31,317.09Zm-3.819,14.054a5.573,5.573,0,0,0,1.322-3.942,5.44,5.44,0,0,0-1.322-3.88,4.786,4.786,0,0,0-6.77,0,5.436,5.436,0,0,0-1.321,3.88,5.569,5.569,0,0,0,1.321,3.942,4.736,4.736,0,0,0,6.77,0Z",
  transform: "translate(-145.95 -307.803)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M326.7,307.8h7.844v30.628H326.7Z",
  transform: "translate(-152.276 -307.803)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M364.9,330.964H348.639a4.544,4.544,0,0,0,1.921,2.661,6.4,6.4,0,0,0,3.57.93,7.708,7.708,0,0,0,2.787-.455,8.189,8.189,0,0,0,2.374-1.486l4.13,4.293q-3.262,3.632-9.538,3.631a15.222,15.222,0,0,1-6.893-1.485,10.944,10.944,0,0,1-6.234-10.113,11.208,11.208,0,0,1,1.59-5.923,11.089,11.089,0,0,1,4.4-4.107,14.091,14.091,0,0,1,12.385-.1,10.546,10.546,0,0,1,4.315,4,11.765,11.765,0,0,1,1.59,6.212Q365.03,329.107,364.9,330.964Zm-14.841-6.934a4.655,4.655,0,0,0-1.548,2.805h9.164a4.66,4.66,0,0,0-1.549-2.805,4.971,4.971,0,0,0-6.068,0Z",
  transform: "translate(-154.815 -309.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M377.024,339.9a14.568,14.568,0,0,1-4.376-1.672L375,332.862a13.283,13.283,0,0,0,3.632,1.507,16.25,16.25,0,0,0,4.17.556,6.684,6.684,0,0,0,2.7-.391,1.23,1.23,0,0,0,.8-1.136q0-.742-.97-1.053a20.137,20.137,0,0,0-3.076-.6,30.205,30.205,0,0,1-4.562-.868,7.025,7.025,0,0,1-3.241-1.98,5.667,5.667,0,0,1-1.362-4.045,6.119,6.119,0,0,1,1.28-3.819,8.477,8.477,0,0,1,3.736-2.641,16.013,16.013,0,0,1,5.884-.97,23.8,23.8,0,0,1,4.83.5,13.886,13.886,0,0,1,4,1.4l-2.351,5.325A13.057,13.057,0,0,0,384.042,323a6.4,6.4,0,0,0-2.724.435,1.29,1.29,0,0,0-.866,1.135c0,.523.315.887.949,1.094a21.9,21.9,0,0,0,3.137.639,34.716,34.716,0,0,1,4.583.95,7.013,7.013,0,0,1,3.158,1.961,5.58,5.58,0,0,1,1.342,3.983,6.052,6.052,0,0,1-1.28,3.777,8.32,8.32,0,0,1-3.778,2.62,16.927,16.927,0,0,1-6.007.949A24.146,24.146,0,0,1,377.024,339.9Z",
  transform: "translate(-160.577 -309.541)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(1354.762 410.036)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M207.742,270.6l-39.1-50.873h-20.19V270.6H113.8V122.845h61.139c18.478,0,33.429,4.109,44.457,12.217v0c12.079,8.9,18.207,21.211,18.207,36.591,0,15.318-6.055,27.473-17.994,36.122a55.052,55.052,0,0,1-12.526,6.658l43.4,56.157Zm-59.289-82.662h26.489c10.16,0,17.787-1.727,22.65-5.139,3.756-2.637,5.358-5.919,5.358-10.974,0-5.509-1.664-9.066-5.561-11.9-4.822-3.506-12.376-5.285-22.447-5.285H148.454Z",
  transform: "translate(-113.804 -122.845)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M294.146,391.1l53.668,41.619V410.782c45.43-8.168,76.935-25.208,76.935-40.581V338.227c0,15.374-31.5,25.458-76.935,29.821v-18.57Z",
  transform: "translate(1208.381 248.283)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M35.556,122.428c-1.052,1.48-2.689,4.686-1.318,10.745,1.086,4.793,5,7.86,7.135,9.217,10.382,6.106,26.92,11.059,47.485,14.507v-21.9c-18.476-5.3-33.7-12.219-44.133-19.5C40.4,117.671,37.286,120,35.556,122.428Z",
  transform: "translate(1255.426 288.519)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M158.95,55.8l-53.668-41.62V36.115c-45.431,8.168-76.936,25.208-76.936,40.58v31.975c0-15.374,31.5-25.458,76.936-29.821v18.57Z",
  transform: "translate(1256.396 306.821)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M439.094,337.221c1.052-1.48,2.689-4.686,1.318-10.745-1.086-4.793-5-7.861-7.135-9.218-6.29-3.7-14.84-6.975-25.176-9.75.034.043-.011,24.9.03,24.966a120.341,120.341,0,0,1,21.794,11.68C434.253,341.978,437.364,339.652,439.094,337.221Z",
  transform: "translate(1187.795 253.832)",
  fill: "#fff"
}));

var SvgRtrWhiteLogo = function SvgRtrWhiteLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348.387,
    height: 360,
    viewBox: "0 0 348.387 360",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRtrWhiteLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rtr-white-logo.38b1981e.svg";
export { ForwardRef as ReactComponent };